import React from 'react';
import { Activity, HelpCircle } from 'lucide-react';
import { AgentType } from '../types';

interface AgentSelectionProps {
  onSelectAgent: (agent: AgentType) => void;
}

export function AgentSelection({ onSelectAgent }: AgentSelectionProps) {
  const agents = [
    {
      id: 'analytics-stream' as AgentType,
      title: 'Deep Analytics (Live)',
      description: 'Watch the AI classify, plan, execute, and summarize in real-time with full transparency',
      icon: Activity,
      color: 'bg-purple-50 hover:bg-purple-100 border-purple-200 hover:border-purple-300'
    },
    {
      id: 'platform-help' as AgentType,
      title: 'Platform Help',
      description: 'Get help with platform features, navigation, and general questions',
      icon: HelpCircle,
      color: 'bg-blue-50 hover:bg-blue-100 border-blue-200 hover:border-blue-300'
    }
  ];

  return (
    <div className="p-4 space-y-3" data-testid="agent-selection-container">
      <div className="text-center mb-4">
        <h4 className="font-medium text-gray-900 mb-1">How can I help you today?</h4>
        <p className="text-sm text-gray-600">Choose what you'd like to do</p>
      </div>
      
      {agents.map((agent) => {
        const IconComponent = agent.icon;
        return (
          <button
            key={agent.id}
            onClick={() => onSelectAgent(agent.id)}
            className={`w-full p-4 rounded-lg border-2 transition-all duration-200 text-left ${agent.color}`}
            data-testid={`agent-selection-${agent.id}-button`}
          >
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <IconComponent className="w-6 h-6 text-gray-700" />
              </div>
              <div className="flex-1">
                <h5 className="font-medium text-gray-900 mb-1">{agent.title}</h5>
                <p className="text-sm text-gray-600">{agent.description}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
